module.exports = __webpack_public_path__ + "img/4e54852b76728b3ca3ba0d5f53ebd385.png";